import React, { useEffect } from 'react';

// Material UI components
import {
  Button,
  Dialog,
  DialogContent,
  Typography,
  Grid,
  Box,
  TextField,
  MenuItem
} from '@mui/material'

//React Hook Form imports
import { useForm } from "react-hook-form"


const ModalErrorVehicle = ({ openError, handleCloseModalError, handleCloseModalErrorAcept, dataModal }) => {
    /* Functions of forms if data.type is vehicle */
    const { register, handleSubmit, formState: { errors }, reset} = useForm()
    const typesError = [
        { id: 1, description: "Inconcistencias con documentos" },
        { id: 2, description: "Se requiere mas información sobre vehiculo" },
        { id: 3, description: "Datos del vehiculo no coinciden con documentos proporcionados" },
    ];

    const onSubmit = async (data,) => {
        //console.log(data) 
        const id = data.type   
        handleCloseModalErrorAcept(id)
    }

    useEffect(() => {
        reset({type: null})
    }, [])

    /* Function to close modal */
    const closeModal = async () => {
        reset({type: null})
        handleCloseModalError()
    }

    return (
        <Dialog
            open={openError}
            onClose={closeModal}        
            hideBackdrop ={true}
            className='modalClient'
            fullWidth
            maxWidth='md'
        >
            <DialogContent className='modalContent'>
                <Grid
                    container
                    item
                    direction="column"
                    justifyContent="center"
                    alignItems="center"
                    xs={12}
                >
                    <Typography
                        variant='h3'
                        style={{ whiteSpace: 'pre-wrap' }}
                    >
                        {dataModal.message}
                    </Typography>

                    {/* Type to notification */}        
                    <Box
                        component="form"
                        onSubmit={handleSubmit(onSubmit)}
                        noValidate
                        sx={{
                            mt: 1,
                            mx: 4,
                            textAlign: "center",
                            minWidth: "-webkit-fill-available",
                        }}
                    >
                        {/* Select type to error (vehicle) */}
                        <Grid
                            container
                            item
                            className="formEvent"
                            columnSpacing={1}
                            rowSpacing={0}
                            xs={12}
                        >
                            <Grid
                                container
                                direction="row"
                                justifyContent="flex-end"
                                alignItems="center"
                                item
                                xs={6}
                            >
                                <Typography variant="body1">Tipo de error a notificar:</Typography>
                            </Grid>
                            <Grid
                                container
                                direction="row"
                                justifyContent="flex-start"
                                alignItems="center"
                                item
                                xs={6}
                            >
                                <TextField
                                    margin="normal"
                                    fullWidth
                                    select
                                    size="small"
                                    style={{ marginTop: 5, marginBottom: 5 }}
                                    defaultValue=''
                                    {...register("type", {
                                        required: "Debe indicarse el error a notificar."
                                    })}
                                    error={!!errors?.type}
                                    helperText={!!errors?.type ? errors.type.message : null}
                                >
                                {
                                    typesError.map((type, index) => (
                                        <MenuItem key={index} value={type.id}>
                                            {type.description}
                                        </MenuItem>
                                    ))
                                }
                                </TextField>
                            </Grid>

                            {/* Button actions */}
                            <Grid
                                container
                                item
                                direction="row"
                                justifyContent="space-evenly"
                                alignItems="center"
                                className='buttonsModal'
                                xs={12}
                            >

                                <Button 
                                    autoFocus
                                    size="small"
                                    variant='contained'
                                    type="submit"
                                >
                                    Notificar
                                </Button>
                                <Button 
                                    size="small"
                                    variant='contained'
                                    onClick={closeModal}
                                >
                                    Regresar
                                </Button>
                            </Grid>
                        </Grid>
                    </Box>


                    
                </Grid>

                
            </DialogContent>
        </Dialog>
    );
}

export default ModalErrorVehicle